import ButtonMenu from "./button-menu";
import { FormattedDollars } from "./formatted-currency";
import LightBox from "./light-box";
import { range } from "../as-range";
import React from "react";
import TowelIcon from "./towel-icon";

var betTypes = [
  "Win",
  "Place",
  "Show",
  "Win/Place",
  "Win/Place/Show",
];

var betTypeMinimums = {
  "Win": 2,
  "Place": 2,
  "Show": 2,
  "Win/Place": 4,
  "Win/Place/Show": 6
};

export default class WagerPadLightbox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBetAmount: 2,
      selectedBetType: "Win"
    };
    this.onChangeBetAmount = this.onChangeBetAmount.bind(this);
    this.onChangeBetType = this.onChangeBetType.bind(this);
  }

  onChangeBetAmount(index) {
    var betAmounts = this.calculateBetAmounts();
    this.setState({ selectedBetAmount: betAmounts[index] }); // eslint-disable-line react/no-set-state
  }

  onChangeBetType(index) {
    var { selectedBetAmount } = this.state;
    var betType = betTypes[index];
    var minimum = betTypeMinimums[betType];
    var betAmount = Math.max(selectedBetAmount, minimum);
    this.setState({ selectedBetAmount: betAmount, selectedBetType: betType }); // eslint-disable-line react/no-set-state
  }

  getBankroll() {
    var { ticket } = this.props;
    return parseFloat(ticket.get("live_bankroll") || 0);
  }

  calculateBetAmounts() {
    var { selectedBetType } = this.state;
    var selectedBetTypeMinimum = betTypeMinimums[selectedBetType];
    return range(selectedBetTypeMinimum, this.getBankroll());
  }

  render () {

    // TODO Determine if we need to change "Horse" to "Runner" or "Greyhound"
    var { onClose, race, raceEntrant, raceEntrants, tournament } = this.props;
    var { selectedBetAmount, selectedBetType } = this.state;

    var title = (
      <span>
        <i className="dw-clipboard dw--baseline" />

        {" "}
        Wager Pad
      </span>
    );
    var raceNumber = tournament.get("races").findIndex(raceId => raceId === race.get("id")) + 1;
    var track = race.get("track_name");
    var trackRaceNumber = race.get("race_number");

    var selectedBetTypeIndex = betTypes.indexOf(selectedBetType);

    var betAmounts = this.calculateBetAmounts();
    var selectedBetAmountIndex = betAmounts.indexOf(selectedBetAmount);
    var amounts = betAmounts.map(amt => <FormattedDollars key={amt} showCents value={amt} />);

    var entrantList = race.get("race_entrants").map(id => raceEntrants.get(id)).sort((a, b) => a.get("lane_number") - b.get("lane_number"));
    var selectedEntrantIndex = entrantList.findIndex(entrant => entrant.get("id") === raceEntrant.get("id"));
    var entrants = entrantList.map(entrant => {
      return (
        <span key={entrant.get("id")}>
          <TowelIcon lane={entrant.get("lane_number")} small />

          <span>
            {entrant.get("horse_name")}
          </span>
        </span>
      );
    }).toJS();

    var remainingBankroll = this.getBankroll() - selectedBetAmount;

    return (
      <LightBox onClose={onClose} title={title}>
        <div className="lightbox_body">
          <h3>
            Place your bet on Race
            {raceNumber}

            {" "}
            (

            {track}
            -

            {trackRaceNumber}
            )!
          </h3>

          <div className="batch-g batch-g--gutter batch-g--padding">
            <div className="batch-c-1-1 batch-c-md-5-24">
              <p className="note-text margin-bottom--is-2">
                Amount:
              </p>

              <ButtonMenu block onChange={this.onChangeBetAmount} selected={selectedBetAmountIndex} short>
                {amounts}
              </ButtonMenu>
            </div>

            <div className="batch-c-1-1 batch-c-md-1-3">
              <p className="note-text margin-bottom--is-2">
                Bet Type:
              </p>

              <ButtonMenu block onChange={this.onChangeBetType} selected={selectedBetTypeIndex} short>
                {betTypes}
              </ButtonMenu>
            </div>

            <div className="batch-c-1-1 batch-c-md-11-24">
              <p className="note-text margin-bottom--is-2">
                Horse:
              </p>

              <ButtonMenu block selected={selectedEntrantIndex} short>
                {entrants}
              </ButtonMenu>
            </div>

            <div className="batch-c-1-1">
              <div className="summary">
                <dl className="summary_row">
                  <dt>
                    Current Bankroll Total:
                  </dt>

                  <dd>
                    <FormattedDollars showCents value={this.getBankroll()} />
                  </dd>
                </dl>

                <dl className="summary_row summary_row--total">
                  <dt>
                    Wager Total:
                  </dt>

                  <dd>
                    <FormattedDollars showCents value={selectedBetAmount} />
                  </dd>
                </dl>

                <dl className="summary_row">
                  <dt>
                    Remaining Bankroll Total:
                  </dt>

                  <dd>
                    <FormattedDollars showCents value={remainingBankroll} />
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>

        <div className="lightbox_footer">
          <button className="btn" onClick={onClose} type="button">
            Cancel
          </button>

          <button className="btn btn--primary" type="button">
            Send Wager
          </button>
        </div>
      </LightBox>
    );
  }
}
